import axios from 'axios';

const GetToken = ({ apiUrl }) =>
  axios.post(`${apiUrl}/SolAgora.svc/getToken`).then(res => res.data);

const GetCliente = ({ apiUrl, cli_codigo }) =>
  axios.post(`${apiUrl}/SolAgora.svc/getCliente`, { cli_codigo })
    .then(res => res.data);

const CheckIntegratorPreRegistration = ({ apiUrl, cnpj }) =>
  axios.post(`${apiUrl}/SolAgora.svc/checkIntegratorPreRegistration`,
    {
      checkIntegratorBody: {
        cnpj
      }
    })
    .then(res => res.data);

const IntegratorClick = ({ apiUrl, cnpj }) =>
  axios.post(`${apiUrl}/SolAgora.svc/integratorClick`,
    {
      cnpj
    })
    .then(res => res.data);

const CheckIntegrator = ({ apiUrl, cnpj }) =>
  axios.post(`${apiUrl}/SolAgora.svc/CheckIntegrator`,
    {
      checkIntegratorBody: {
        cnpj
      }
    })
    .then(res => res.data);

const CreateProject = ({ apiUrl, token, name, document, birthdate, phone, cep, email, cnpj, codigoPedido }) =>
  axios.post(`${apiUrl}/SolAgora.svc/createProject`,
    {
      createProjectBody:
      {
        token,
        name,
        document,
        birthdate,
        phone,
        cep,
        email,
        cnpj,
        codigoPedido
      }
    })
    .then(res => res.data);

const Simulation = ({ apiUrl, token, idProject, price, consumerEnergyBill, consumerEnergykwh, monthlyIncome }) =>
  axios.post(`${apiUrl}/SolAgora.svc/simulation`,
    {
      simulationBody:
      {
        token,
        idProject,
        price,
        consumerEnergyBill,
        consumerEnergykwh,
        monthlyIncome
      }
    })
    .then(res => res.data);

const PreAnalysis = ({ apiUrl, token, idProject, codigoPedido }) =>
  axios.post(`${apiUrl}/SolAgora.svc/preAnalysis`,
    {
      preAnalysisBody:
      {
        token,
        idProject,
        codigoPedido
      }
    })
    .then(res => res.data);

const SendProposal = ({ apiUrl, token, idProject, resultadoSimulacao, address, installationAddress, regionalDocument, motherName, hardwareCost, laborCost, power, codigoPedido }) =>
  axios.post(`${apiUrl}/SolAgora.svc/sendProposal`,
    {
      proposalBody:
      {
        token,
        idProject,
        regionalDocument: regionalDocument || '',
        motherName: motherName || '',
        dadosSimulation: resultadoSimulacao,
        address,
        installationAddress,
        hardwareCost,
        laborCost,
        power,
        codigoPedido
      }
    })
    .then(res => res.data);

const OpenSimulate = ({ apiUrl, token, price, monthly_income, document }) =>
  axios.post(`${apiUrl}/SolAgora.svc/openSimulate`,
    {
      openSimulateBody:
      {
        token,
        price,
        monthly_income,
        document
      }
    })
    .then(res => res.data);

const GetDadosProjetoSolAgora = ({ apiUrl, codigoPedido }) =>
  axios.post(`${apiUrl}/SolAgora.svc/getDadosProjetoSolAgora`,
    {
      codigoPedido
    })
    .then(res => res.data);

export default {
  GetToken,
  CheckIntegratorPreRegistration,
  IntegratorClick,
  CheckIntegrator,
  GetCliente,
  CreateProject,
  Simulation,
  PreAnalysis,
  SendProposal,
  OpenSimulate,
  GetDadosProjetoSolAgora
}